import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-unsubscribe-page',
  templateUrl: './unsubscribe-page.component.html',
  styleUrls: ['./unsubscribe-page.component.css'],
})
export class UnsubscribePageComponent implements OnInit {
  private listApi = environment.url + environment.unsubscribe;
  /**
   * Creates an instance of UnsubscribePageComponent.
   * @param route The ActivatedRoute service is used to extract the _id parameter
   * from the URL.
   * @param makeapi The ApiService is used to make a POST request to the unsubscribe API.
   */
  constructor(private route: ActivatedRoute, private makeapi: ApiService) {}

  /**
   * Component lifecycle method that is called when the component is initialized.
   * This method retrieves the _id parameter from the URL and unsubscribes the user
   * with the given _id.
   */
  ngOnInit(): void {
    /**
     * Extract the _id parameter from the URL using the ActivatedRoute service.
     * The filter operator is used to ensure that the _id parameter is present in
     * the URL.
     */
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        /**
         * Unsubscribe the user with the given _id using the ApiService.
         * The method returns a response from the server, which is checked in
         * the subscribe callback.
         */
        this.makeapi
          .method(this.listApi + params._id, '', 'getunauth')
          .subscribe((data) => {
            /**
             * If the response status is 'Success', then the user has been
             * unsubscribed successfully.
             */
            if (data.responseStatus === 'Success') {
            }
          });
      });
  }
}
